import React from 'react';
import {
  KFLIcon,
  KFLDropdown,
  KFLDropdownItem,
} from '@kamstrup/kamstrup-frontend-library';
import * as m from '../../../modules/dialogs/download/messages';
import { TranslateType, MessageType } from '../../../core/localization';
import FlaggedMsg, { FlagTypes } from '../../shared/flaggedMsg';
import { FileTypes } from '../../../modules/dialogs/download';

interface Props {
  fileTypeOptions: string[];
  fileType: string;
  setFileType: (value: string) => void;
  pwd: string;
  setPwd: (value: string) => void;
  error: MessageType;
  numberOfFiles: boolean;
  translate: TranslateType;
}
const DownloadFileType: React.FC<Props> = (props) => {
  const splitFileWarn = props.translate(m.msgSplitFileWarn(props.fileType));
  const formatLabel = props.translate(m.msgFileFormatLabel);
  const pwdLabel = props.translate(m.msgKEMPwdLabel);
  const pwdInfo = props.translate(m.msgKEMPwdInfo);
  const pwdWarn = props.translate(m.msgKEMPwdWarn);
  const sigfoxWarn = props.translate(m.msgSigFoxWarn);

  const onChangePwd = (e: React.FormEvent<HTMLInputElement>) => {
    props.setPwd(e.currentTarget.value);
  };

  return (
    <div key="md-download-options" className="download_types">
      <span className="download-filetype-label">{formatLabel}</span>
      <KFLDropdown key="download_types" fullWidth placeholderText="">
        {props.fileTypeOptions.map((i) => (
          <KFLDropdownItem
            key={`download_types_${i}`}
            onClick={() => props.setFileType(i)}
            selected={props.fileType === i}
          >
            {i}
          </KFLDropdownItem>
        ))}
      </KFLDropdown>
      {[FileTypes.KEM, FileTypes.KEM2].includes(props.fileType) && (
        <div>
          <div>
            <div className="KFLInput">
              <label htmlFor="kem-pwd">
                <span>
                  {pwdLabel}
                  <span title={pwdInfo} className="download_pwd_info_icon">
                    <KFLIcon name="Info" color="#009ca6" size="xs" />
                  </span>
                </span>
                <input
                  id="kem-pwd"
                  type="password"
                  value={props.pwd}
                  onChange={onChangePwd}
                />
              </label>
            </div>
            {props.error ? (
              <FlaggedMsg label={props.error} type={FlagTypes.Error} />
            ) : (
              <></>
            )}
          </div>

          <p>{pwdWarn}</p>
        </div>
      )}
      {[FileTypes.KEM/*, FileTypes.XML, FileTypes.OMS*/].includes(props.fileType) &&
        props.numberOfFiles && (
          <p>
            <em>{splitFileWarn}</em>
          </p>
        )}
      {/*[FileTypes.XML, FileTypes.OMS].includes(props.fileType) && (
        <UnsecureExport />
      )*/}
      {props.fileType === FileTypes.SIGFOX && (
        <div>
          <p>{sigfoxWarn}</p>
        </div>
      )}
    </div>
  );
};

export default DownloadFileType;
